import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App.tsx';
import React from 'react';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
